<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      isLoading: false
    }
  },
  async mounted() {
    
  }
}
</script>

<style>
:root {
  /* The WebView draws beneath the status bar on both app clients. */
  --battle-safe-top: max(24px, env(safe-area-inset-top));
  --battle-header-height: calc(56px + var(--battle-safe-top));
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
  min-height: 100vh;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}
</style>
